import React from 'react';
import { ClassAssembly5E2026 } from '../views';

const ClassAssemblyPage = () => {
    return <ClassAssembly5E2026 />;
  };
  
  export default ClassAssemblyPage;